import { render } from "./GainPromotions.vue?vue&type=template&id=0710d1b4&ts=true"
import script from "./GainPromotions.vue?vue&type=script&lang=ts"
export * from "./GainPromotions.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__